import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ServiceStock } from 'src/app/service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { jqxChartComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxchart';

@Component({
  selector: 'app-gotx-chart',
  templateUrl: './gotx-chart.component.html'
})
export class GotxChartComponent implements OnInit {

  data: any[] = [];
  padding: any = { left: 5, top: 5, right: 5, bottom: 5 };
  titlePadding: any = { left: 90, top: 0, right: 0, bottom: 10 };

  @Input('exchange') exchange: string;
  @Input('symbol') symbol: string;
  @Input('rangeSelector') rangeSelector: boolean = false;
  @Input('chartType') chartType: string = 'combinedchart';
  @Input('width') width: number;

  @ViewChild('gotxChart', { static: false }) gotxChart: jqxChartComponent;

  xAxis: any = {
    dataField: 'timeValue',
    displayText: 'Time',
    showGridLines: true,
    axisSize: 'auto'
  };
  seriesGroups: any[] = [];

  columnChart = {
    type: 'column',
    alignEndPointsWithIntervals: true,
    valueAxis: {
      position: 'right',
      title: { text: 'Trade Volume' },
      formatSettings: {
        thousandsSeparator: ','
      },
      displayValueAxis: true,
      axisSize: 'auto',
      tickMarksColor: '#888888',
      labels: {
        horizontalAlignment: 'left'
      }
    },
    toolTipFormatSettings: {
      thousandsSeparator: ','
    },
    series: [
      { dataField: 'volume', displayText: 'Trade Volume', useGradientColors: false, fillColor: '#49e649' }
    ]
  };

  lineChart = {
    type: 'line',
    valueAxis: {
      title: { text: 'Net Change Price<br>' },
      formatSettings: {
        decimalPlaces: 2
      },
      tickMarks: { color: '#888888' },
      gridLines: { visible: false },
    },
    toolTipFormatSettings: {
      decimalPlaces: 2,
      decimalSeparator: '.'
    },
    series: [
      { dataField: 'price', displayText: 'Trade Price', fillColor: '#f930ec' }
    ]
  };

  constructor(private services: ServiceStock) { }

  ngOnInit() {
    // let res = {
    //   "respCode": "0", "errMsg": "", "response": [
    //     { "price": 4.7, "volume": 13078.0, "time": 1664169210000, "timeValue": "10:43:30" }, { "price": 4.4, "volume": 13130.0, "time": 1664170344000, "timeValue": "11:02:24" }, { "price": 4.8, "volume": 13142.0, "time": 1664175004000, "timeValue": "12:20:04" }, { "price": 4.5, "volume": 13070.0, "time": 1664175356000, "timeValue": "12:25:56" }, { "price": 4.5, "volume": 13146.0, "time": 1664177138000, "timeValue": "12:55:38" }, { "price": 4.6, "volume": 13146.0, "time": 1664178250000, "timeValue": "13:14:10" }, { "price": 4.6, "volume": 13146.0, "time": 1664180602000, "timeValue": "13:53:22" }, { "price": 4.4, "volume": 13166.0, "time": 1664184064000, "timeValue": "14:51:04" }, { "price": 4.6, "volume": 13174.0, "time": 1664186129000, "timeValue": "15:25:29" }, { "price": 4.3, "volume": 13074.0, "time": 1664189264000, "timeValue": "16:17:44" }, { "price": 4.1, "volume": 13078.0, "time": 1664203149000, "timeValue": "20:09:09" }, { "price": 4.9, "volume": 13182.0, "time": 1664204000000, "timeValue": "20:23:20" }, { "price": 4.3, "volume": 13194.0, "time": 1664207465000, "timeValue": "21:21:05" }, { "price": 4.7, "volume": 13206.0, "time": 1664211881000, "timeValue": "22:34:41" }, { "price": 4.0, "volume": 13206.0, "time": 1664215347000, "timeValue": "23:32:27" }
    //   ], "sessionResponse": null, "target": null
    // }

    // let resp = res['response'];

    // this.data = res['response'];

    // setTimeout(() => {
    //   this.data = [{ "price": 4.1, "volume": 13072.0, "time": 1664169210000, "timeValue": "10:43:30" },
    //   { "price": 4.5, "volume": 13074.0, "time": 1664169210000, "timeValue": "10:45:30" },
    //   { "price": 4.8, "volume": 13078.0, "time": 1664169210000, "timeValue": "10:48:30" }];
    //   // this.gotxChart.update();
    // }, 5000);
    // setTimeout(() => {
    //   this.data = [];
    // }, 10000);

    if (this.rangeSelector) {
      this.xAxis.rangeSelector = {
        size: 80,
        padding: { top: 10, bottom: 0 },
        backgroundColor: 'transparent',
        showGridLines: false
      };
    }

    if (this.chartType == "line") {
      this.seriesGroups.push(this.lineChart);
    } else {
      this.seriesGroups.push(this.columnChart);
      this.seriesGroups.push(this.lineChart);
    }
    
    this.getChartData(this.exchange, this.symbol);
  }

  ngOnChanges() {
    // chartupdate() {
    // console.log("change chart");

    // let res = {"respCode":"0","errMsg":"","response":[{"price":63.9,"volume":0.0,"time":1665032659000,"timeValue":"10:34:19"},{"price":78.1,"volume":44.0,"time":1665032956000,"timeValue":"10:39:16"}],"sessionResponse":null,"target":null};
    // this.data = res['response'];

    this.getChartData(this.exchange, this.symbol);
  }

  getWidth(): any {
    return this.width;
    // if (document.body.offsetWidth < 850) {
    //   return '90%';
    // }

    // return 850;
  }

  getChartData(exchange, symbol) {    
    // console.log("this.exchange, this.symbol");
    // console.log(exchange, symbol);

    if (symbol != null && symbol != undefined && symbol != "") {
      let inputMap = new Map();
      inputMap.set('Body.exchange', exchange);
      inputMap.set('Body.symbol', symbol);
      inputMap.set('Body.chartType', "combinedchart");
      this.services.http.fetchApi('/chart/data', 'POST', inputMap).subscribe(
        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          var respCode: any = res['respCode'];
          if (respCode != null && respCode == 0) {
            if(res['response'] != null){
              this.data = res['response'];
            } else {
              this.data = [];
            }
            
          } else {
            this.data = [];
          }
        },
        async (httpError) => {
          var err = httpError['error']
          if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
          }
          this.data = [];
        }
      );
    }
  }
}
